<template>
  <SysDataTableExpand
    :height="getAlturaAtual() - 230"
    :item-height="45"
    :headers="headers"
    :callbacks="callbacks_computed"
    :hide-border-bottom-tr="false"
    :arrow-icon-size="20"
    hide-default-footer
    title_icon_expand="CLICK PARA  VER DETALHES DA CARTEIRA"
    :item-class="item => ({ 'bg-red-50': Number(item.idcomprador) === 0 && Number(item.$nivel_linha) === 0})"
    @callback-resetar-grid="f => callbackResetarDadosGrid = f"
  >
    <template #top>
      <div class="pt-3 pb-5">
        <div class="d-flex align-center mb-6">
          <NovaCarteira @carteira-atualizada="callbackResetarDadosGrid" />
          <SincronizacaoAlteracaoCarteiras class="ml-5" />
        </div>

        <span class="font-16 font-weight-medium" style="color: #013254">Lista de Carteiras</span>
      </div>
    </template>

    <template v-for="(item, key) in headers" #[`header.${item.value}`]>
      <div :key="key" class="d-flex align-center">
        <v-icon v-if="item.icone" color="#68686E" class="pr-1">
          {{ item.icone }}
        </v-icon>

        <span class="font-weight-bold font-14 text-black">
          {{ item.text }}
        </span>
      </div>
    </template>

    <template #item.indentacao="{ item }">
      <div v-if="item.$nivel_linha" class="d-flex align-center">
        <div
          v-for="numero in (item.$nivel_linha * 3) - (item.linha_titulo ? 2 : 0)"
          :key="numero"
          :style="{
            width: '7px',
            height: numero === (item.$nivel_linha * 3) ? '25px' : '35px',
            borderRight: '2px dashed #9abef5',
          }"
          class="mr-1"
        />
      </div>
    </template>

    <template #item.icon-expandir-recolher="{ item }">
      <div v-if="item.linha_titulo" class="d-flex align-center ml-n1">
        <v-icon :size="23" class="mr-1">mdi-chevron-down</v-icon>
      </div>
    </template>

    <template #_item.descricao_analise="{ item }">
      <div v-if="item.linha_titulo" class="d-flex align-center">
        <v-icon :size="20">{{ item.left_icone }}</v-icon>
        <span class="font-weight-bold font-14 pl-2">{{ item.titulo }}</span>
      </div>

      <div v-else-if="Number(item.idcomprador) === 0 && Number(item.$nivel_linha) === 0">
        <span class="bg-red-200 px-10 py-1 bra-20">
          Não atribuídos
        </span>
      </div>
    </template>

    <template #item.actions="{ item }">
      <div
        v-if="item.idproduto === undefined && !item.linha_titulo"
        class="d-flex align-center"
      >
        <NovaCarteira
          :idcomprador="item.idcomprador"
          :idfornecedor="item.idfornecedor"
          :idsegmento="item.idsegmento"
          :idsecao="item.idsecao"
          :idcategoria="item.idcategoria"
          title="FAÇA ALTERAÇÕES EM UMA CARTEIRA JÁ EXISTENTE."
          @carteira-atualizada="callbackResetarDadosGrid"
        >
          <template #ativador="{ callback }">
            <v-btn icon @click="callback">
              <v-icon size="28">$PencilSimple</v-icon>
            </v-btn>
          </template>
        </NovaCarteira>

        <Exclusao v-if="Number(item.idcomprador) > 0" :item="item" @item-excluido="callbackResetarDadosGrid" />
      </div>
    </template>
  </SysDataTableExpand>
</template>

<script setup>
import NovaCarteira from "@/components/cadastros/CarteiraV2Compradores/NovaCarteira/Index.vue";
import { getAlturaAtual } from "@/helpers/ResponsiveHeight";
import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index.vue";
import {computed, ref} from "vue";
import api from "@/api/api";
import Exclusao from "@/components/cadastros/CarteiraV2Compradores/Exclusao.vue";
import {formatarValor} from "@/helpers";
import SincronizacaoAlteracaoCarteiras from "@/components/cadastros/CarteiraV2Compradores/SincronizacaoAlteracaoCarteiras.vue";

const callbackResetarDadosGrid = ref();

const headers = [
  { text: 'Nome da Carteira', value: 'descricao_analise' },
  { text: 'Qtd. de Fornecedores', value: 'qtd_fornecedores', icone: '$Storefront' },
  { text: 'Qtd. de Segmentos', value: 'qtd_segmentos', icone: '$PuzzlePiece' },
  { text: 'Qtd. de Seções', value: 'qtd_secoes', icone: '$PuzzlePiece' },
  { text: 'Qtd. de Categorias', value: 'qtd_categorias', icone: '$PuzzlePiece' },
  { text: 'Qtd. de Produtos', value: 'qtd_produtos', icone: '$Boxes' },
  { text: 'Ações', value: 'actions' }
];

const callbacks_computed = computed(() => {
  return [
    buscarCarteiras,
    buscarFornecedoresCarteira,
    buscarSegmentosCarteira,
    buscarSecoesCarteira,
    buscarCategoriasCarteira,
    buscarProdutosCarteira,
  ];
});

async function buscarCarteiras() {
  const resposta = await api.get('carteiras/v2');
  return definirValoresPadrao(resposta.data.carteiras);
}

function definirValoresPadrao(itens, icone = null) {
  return itens.map(item => {
    return {
      ...item,
      left_icone: icone,
      qtd_fornecedores: Number(item.qtd_fornecedores) > 0 ? formatarValor(item.qtd_fornecedores) : '-',
      qtd_segmentos: Number(item.qtd_segmentos) > 0 ? formatarValor(item.qtd_segmentos) : '-',
      qtd_secoes: Number(item.qtd_secoes) > 0 ? formatarValor(item.qtd_secoes) : '-',
      qtd_categorias: Number(item.qtd_categorias) > 0 ? formatarValor(item.qtd_categorias) : '-',
      qtd_produtos: Number(item.qtd_produtos) > 0 ? formatarValor(item.qtd_produtos) : '-',
    };
  });
}

function formatarLinhas(itens, titulo, icone) {
  const itens_tratados = definirValoresPadrao(itens, icone);

  itens_tratados.unshift({
    linha_titulo: true,
    titulo: titulo,
    left_icone: icone,
  });

  return itens_tratados;
}

async function buscarFornecedoresCarteira({ idcomprador }) {
  const resposta = await api.get(`carteiras/v2/fornecedores`, { params: { idcomprador }});

  return formatarLinhas(
    resposta.data.fornecedores,
    'Fornecedores',
    '$Storefront'
  );
}

async function buscarSegmentosCarteira({ idcomprador, idfornecedor }) {
  const resposta = await api.get(
    `carteiras/v2/fornecedores/segmentos`,
    { params: { idcomprador, idfornecedor }}
  );

  return formatarLinhas(
    resposta.data.segmentos,
    'Segmentos',
    '$PuzzlePiece'
  );
}

async function buscarSecoesCarteira({ idcomprador, idfornecedor, idsegmento }) {
  const resposta = await api.get(
    `carteiras/v2/fornecedores/segmentos/secoes`,
    { params: { idcomprador, idfornecedor, idsegmento }}
  );

  return formatarLinhas(
    resposta.data.secoes,
    'Seções',
    '$PuzzlePiece'
  );
}

async function buscarCategoriasCarteira({ idcomprador, idfornecedor, idsegmento, idsecao }) {
  const resposta = await api.get(
    `carteiras/v2/fornecedores/segmentos/secoes/categorias`,
    { params: { idcomprador, idfornecedor, idsegmento, idsecao }}
  );

  return formatarLinhas(
    resposta.data.categorias,
    'Categorias',
    '$PuzzlePiece'
  );
}

async function buscarProdutosCarteira({ idcomprador, idfornecedor, idsegmento, idsecao, idcategoria }) {
  const resposta = await api.get(
    `carteiras/v2/fornecedores/segmentos/secoes/categorias/produtos`,
    { params: { idcomprador, idfornecedor, idsegmento, idsecao, idcategoria }}
  );

  return formatarLinhas(
    resposta.data.produtos,
    'Produtos',
    '$Boxes'
  );
}
</script>
